module.exports = __webpack_public_path__ + "static/img/dsk-about-bg1.c345225.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dsk-about-bg1.jpg
// module id = 226
// module chunks = 1